export const MAX_FILE_BYTES = 10 * 1024 * 1024;
export const MAX_PER_TRANSACTION = 10;

export const ALLOWED_MIME_TO_EXT: Record<string, string> = {
  'application/pdf': 'pdf',
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/webp': 'webp',
};

export const ALLOWED_MIME_TYPES = Object.keys(ALLOWED_MIME_TO_EXT);
